<template>
  <div id="aff" class="modal fade black-modal" role="dialog" data-backdrop="true" data-keyboard="false">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="sticky-top container-fluid" data-padding-right="" data-margin-right="" style="">
          <div class="align-items-center justify-content-center py-0 modalTopClose row">
            <div class="col-2">
              <button data-dismiss="modal" class="button-close mt-1">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left"
                  class="svg-inline--fa fa-arrow-left p-0 text-white" role="img" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512" style="font-size: 20px;">
                  <path fill="currentColor"
                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z">
                  </path>
                </svg>
              </button>
            </div>
            <div class="d-flex justify-content-center col-8">
              <a data-animatable="fadeInUp" data-delay="500" href="/">
                <div class="logo-title pt-1 img-fluid my-2">
                  <img alt="ZEAGAME แทงบอลออนไลน์ คาสิโนออนไลน์" loading="eager" width="190" height="48" decoding="async"
                    data-nimg="1" class="animated fadeInUp img-fluid" src="/static/img/logo/logo.png"
                    style="color: transparent;" />
                </div>
              </a>
            </div>
            <div class="text-right col-2">
              <button data-dismiss="modal" class="button-close">
                <img src="/static/img/landing/closeIcon.png" width="40" height="40" alt="ปิด" class="" />
              </button>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <div class="container">
            <h5>แนะนำเพื่อน</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="py-4 container">

            <div class="text-left p-0 card-body">
              <div class="row">
                <div class="col">
                  <form class="">
                    <div class="justify-content-center row">
                      <div class="col-12">
                        <div class="remain-credit money-user p-4">฿ <span class="text-warning">{{ UserInfo.internalWallet.affiliateWallet }}</span>
                          <div class="col" style="color: rgb(31, 224, 112);"> เครดิตคงเหลือ (บาท)</div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="remain-credit money-user p-4"><span class="text-warning">{{ Users.length }}</span>
                          <div class="col" style="color: rgb(31, 224, 112);"> แนะนำแล้ว </div>
                        </div>
                      </div>

                      <div class="register-body-form m-3 pt-2">
                        <div class="position-relative col-12">
                          <div><input class="form-control" :value="affiliateLink" @click="copyAF(affiliateLink)" type="text"
                              value="100" inputmode="numeric">
                              <button class="btn-copy px-0"><img src="/static/img/landing/copy-icon.png" width="18" height="18" alt="คัดลอก" class="img-fluid ml-2"></button>
                          </div>
                        </div>
                      </div>
                      <div class="position-relative p-4 col-12">
                        <div class="">
                          <div class="btn-modal btn-withdraw"><button  @click="WithdrawAffiliate()" type="submit" class="btn btn-2022"
                              style="background-size: 100%;">ถอนเงิน</button></div>
                        </div><a class="close-modal-button" href="/home#"></a>
                      </div>
                       
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
           
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";
import { fetchAffiliate, WithdrawAffiliate } from "@/services/modules/af.js";
import moment from "moment";

export default {
  name: "AfForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      income: 0,
      Users: [],
      Trans: [],
      TransIncome: [],
      userData: {},
      setting: {},
      affiliateLink: "",
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    getDate: function (data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },
    async copyAF(item) {
      this.$copyText(item, this.$refs.af);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },
    async fetchAffiliate() {
      await fetchAffiliate((res) => {
        if (res.status) {
          this.income = res.data.balance;
          this.Trans = res.data.transaction;
          this.Users = res.data.Users;
          this.TransIncome = res.data.transaction_incomes;
          this.setting = res.data.setting;
        }
      });
    },

    async WithdrawAffiliate() {
      await WithdrawAffiliate((res) => {
        if (res.status) {
          this.$swal.fire("Success!", "", "success");
        } else {
          this.$swal.fire(res.message, "", "error");
        }
      });
    },
  },
  async mounted() {
    await this.fetchAffiliate();
    this.affiliateLink = "";
    this.affiliateLink =
      window.location.origin + "/?shareToken=" + this.UserInfo.affiliateKey;
    $(".overlaymodal").on("click", function () {
      $("#friendstab").modal("hide");
    });
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/form/AfForm.vue